import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "size"];
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var IconChat24pxMedium = function IconChat24pxMedium(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color
  }, otherProps), {}, {
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 2.959c-5.086 0-9.002 3.64-9.002 7.89 0 2.291 1.119 4.381 2.956 5.844.443.351.474.849.45 1.111a2.32 2.32 0 01-.188.682c-.138.326-.352.703-.533 1.02l-.054.095c-.047.082-.092.161-.133.236.163-.033.34-.073.528-.12a38.403 38.403 0 002.772-.822c.72-.24 1.46-.28 2.152-.21.344.036.695.054 1.051.054 5.548 0 9.001-3.609 9.001-7.89 0-4.25-3.916-7.89-9-7.89zM4.595 19.952c-.022-.003-.018-.004.004 0h-.004zM.998 10.849c0-5.57 5.04-9.89 11.001-9.89C17.961.959 23 5.279 23 10.849c0 5.538-4.508 9.89-11 9.89-.425 0-.843-.022-1.255-.064-.477-.048-.923-.013-1.317.118a40.29 40.29 0 01-2.929.867c-.507.124-1.019.23-1.45.273a3.292 3.292 0 01-.668.007c-.177-.019-.564-.079-.868-.383a1.361 1.361 0 01-.382-1.04c.012-.274.091-.53.166-.727.15-.395.396-.83.593-1.177l.036-.064c.146-.257.267-.47.357-.648-2.01-1.779-3.285-4.27-3.285-7.052z"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.111 8.626a1 1 0 011-1h7.779a1 1 0 110 2H8.111a1 1 0 01-1-1z"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.111 13.071a1 1 0 011-1h4.445a1 1 0 110 2H8.111a1 1 0 01-1-1z"
    })]
  }));
};
export default IconChat24pxMedium;